import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  SegmentLOBArrayModel,
  SegmentLOBModel,
} from "../../models/SegmentLOBModel";

const initialSegmentLOBState: SegmentLOBArrayModel = {
  all_SegmentLOBs: [],
  segmentsByBu: [],
  particular_SegmentLOB: {
    segmentlobid: 0,
    name: "",
    description: "",
    isActive: false,
  },
  isSegmentLOBsFetching: false,
};
const SegmentLOBSlice = createSlice({
  name: "SegmentLOB",
  initialState: initialSegmentLOBState,
  reducers: {
    setSegmentLOBs(state, action: PayloadAction<SegmentLOBModel[]>) {
      state.all_SegmentLOBs = action.payload;
    },
    setParticularSegmentLOB(state, action: PayloadAction<SegmentLOBModel>) {
      state.particular_SegmentLOB = action.payload;
    },
    setSegmentsByBU(state, action: PayloadAction<SegmentLOBModel[]>) {
      state.segmentsByBu = action.payload;
    },
    setIsSegmentLOBsFetching(state, action: PayloadAction<boolean>) {
      state.isSegmentLOBsFetching = action.payload;
    },
  },
});
export default SegmentLOBSlice;
